import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { findDOMNode } from "react-dom"
import Measure from "react-measure"
import { withRadium, DetectCompact } from "higher-order-components"
import { isFinite } from "utils"
import debounce from 'AtomicUtils/debounce'
import { WINDOW } from "constants/environment"

/* Sticky Nav Component */
export class Sticky extends PureComponent {
  constructor() {
    super()
    this.state = {
      fixed: false
    }
  }
  componentDidMount() {
    this.element = findDOMNode(this)
    this.calculateFixed()
    WINDOW.addEventListener("scroll", debounce(this.calculateFixed, 250), {
      passive: true
    })
  }
  componentWillUnmount() {
    WINDOW.removeEventListener("scroll", debounce(this.calculateFixed,250), {
      passive: true
    });
  }
  calculateFixed = () => {
    const { top } = this.element.getBoundingClientRect()
    const fixed = isFinite(top) ? top <= 0 : false
    this.setState({ fixed })
  }
  /**
   * @param {Array} components - Array of Components.
   * @returns {ReactElement} React Component
   */
  render() {
    const { compact, children } = this.props
    const { fixed, height } = this.state
    return (
      <Measure
        bounds
        onResize={({ bounds: { height } }) => {
          this.setState({ height })
        }}>
        {({ measureRef }) => (
          <div ref={measureRef} data-test="sticky">
            <div style={[!fixed ? styles.base: {}, fixed ? { paddingTop: `${height}px` } : ""]}>
                <div style={[fixed ? styles.sticky : ""]}>{children}</div>
              </div>
          </div>
        )}
      </Measure>
    )
  }
}

Sticky.propTypes = {
  compact: PropTypes.bool
}

export default withRadium(DetectCompact())(Sticky)

const styles = {
  base: {
    position: "relative",
    zIndex: 2,
    width: "100%",
    transform: "translate3d(0, 0, 0)"
  },
  sticky: {
    position: "fixed",
    top: "0",
    zIndex: 21,
    width: "100%",
    background: "white",
    transform: "translate3d(0, 0, 0)"
  }
}



// WEBPACK FOOTER //
// ./src/containers/sticky/index.jsx